const LocalizzazioneSchema = {
    title: 'Localizzazione',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['title', 'description', 'street', 'zipCode', 'city', 'mapPosition', 'coordinates'],
      },
    ],
    properties: {
      title: {
        title: 'Titolo',
        type: 'string',
      },
      description: {
        title: 'Descrizione',
        type: 'string',
        widget: 'richtext',
      },
      street: {
        title: 'Via',
        type: 'string',
      },
      zipCode: {
        title: 'CAP',
        type: 'string',
      },
      city: {
        title: 'Città',
        type: 'string',
      },
      mapPosition: {
        title: 'Posizione della mappa',
        type: 'string',
        factory: 'Choice',
        choices: [
          ['left', 'Sinistra'],
          ['right', 'Destra'],
        ],
        default: 'left',
      },
      coordinates: {
        title: 'Coordinate (lat, lng)',
        type: 'array',
        items: {
          type: 'number',
        },
        default: [44.809984, 10.323001], 
        widget: 'hidden', // Nascondi il campo dalla form
      },
    },
    required: ['title', 'street', 'zipCode', 'city'], // Rendiamo obbligatori i campi dell'indirizzo
  };
  
  export default LocalizzazioneSchema;